export default function Trusted() {
  const organizations = [
    { icon: 'ri-building-line', name: 'Factories' },
    { icon: 'ri-store-line', name: 'Shopping Malls' },
    { icon: 'ri-hospital-line', name: 'Hospitals' }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-teal-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Trusted by Leading Organizations
          </h2>
          <p className="text-xl text-gray-600">Serving Bahrain's Top Institutions</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {organizations.map((org, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-md hover:shadow-lg transition-shadow text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className={`${org.icon} text-teal-500 text-5xl`}></i>
              </div>
              <h4 className="font-bold text-gray-900 text-base">{org.name}</h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
